import { render, staticRenderFns } from "./StageDetails.vue?vue&type=template&id=2873c03f&scoped=true&"
import script from "./StageDetails.vue?vue&type=script&lang=ts&"
export * from "./StageDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StageDetails.vue?vue&type=style&index=0&id=2873c03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873c03f",
  null
  
)

export default component.exports